import { automaticProductSource } from './constants'

const getSourceValue = (productSource, productSourceValue) => {
  if (productSource === automaticProductSource) return undefined

  return productSourceValue
}

export const getRecommendedProductsParams = ({ page, maxProducts, productSource, productSourceValue }) => {
  return {
    page,
    page_size: maxProducts,
    source: productSource,
    source_value: getSourceValue(productSource, productSourceValue),
  }
}
